import { motion } from "framer-motion";
import { WhatsAppIcon } from "@/components/icons";
import { scrollToContact } from "@/lib/scroll";

const FloatingWhatsApp = () => (
  <motion.button
    type="button"
    data-testid="floating-whatsapp-button"
    onClick={scrollToContact}
    aria-label="Message us on WhatsApp — choose a contact"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.3, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.1 }}
    whileTap={{ scale: 0.92 }}
    className="fixed bottom-6 right-6 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_12px_32px_rgba(37,211,102,0.45)]"
  >
    <span className="animate-wa-pulse absolute inset-0 -z-10 rounded-full bg-[#25D366]" />
    <WhatsAppIcon className="h-7 w-7" />
  </motion.button>
);

export default FloatingWhatsApp;
